/*
 * @Description: 头部模块状态管理
 * @Author: loong
 * @Date: 2022-09-08 14:56:02
 * @LastEditors: loong
 * @LastEditTime: 2022-09-13 15:01:59
 */
export default { 
    state: {
        activeIndex: "/", // 选中的tab
        activeStyle:"",//当前样式
    },
    getters: {
      getActive (state) {
        return state.activeIndex
      },
      
    },
    mutations: {
      setActive (state, data) {
        state.activeIndex = data;
      },
     
    },
    actions: {
        setActive ({ commit }, data) {
        commit('setActive', data);
      },
    }
  }